import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, Scroll } from '@angular/router';
import { filter } from 'rxjs';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.html',
  styleUrls: ['./faqs.css'],
  imports: [NavMenu, RouterLink],
})
export class Faqs implements OnInit {

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller) { }

  ngOnInit() {
    this.router.events.pipe(
      filter((e: any): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {
      if (e.position) {
        this.viewportScroller.scrollToPosition(e.position);
      } else if (e.anchor) {
        this.viewportScroller.scrollToAnchor(e.anchor);
      } else {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }

}
